<div class="pdq-iq-container" #pdqIqContainer>
  <div class="header">
    <pdq-button variant="light" icon="side_left_arrow" size="large" (onClick)="navigateToPackages()"> </pdq-button>
    <div class="title">PDQ IQ Settings</div>
  </div>
  @if (pdqIqForm) {
    <div [formGroup]="pdqIqForm" class="pdq-iq-params">
      <div class="form-wrapper">
        @if (showFormErrors && getFormErrors().length) {
          <div class="banner-wrapper">
            <pdq-banner variant="danger" bannerTitle="Error">
              @for (error of getFormErrors(); track error) {
                <ul>
                  <li>{{ error }}</li>
                </ul>
              }
            </pdq-banner>
          </div>
        }
        <label class="sub-title">Map Shopify Variant Metafields</label>
        <div class="fields-wrapper">
          @for (field of fields; track field; let i = $index) {
            <div class="form-row">
              <label class="field-name">{{ field.name }}:</label>
              <div class="input-wrapper">
                <pdq-input
                  formControlName="field{{ i }}"
                  type="text"
                  variant="form"
                  background="default"
                  [border]="true"
                  placeholder="namespace.key"
                  [withIcon]="false"
                  [autofocus]="false"
                  [autocompleteMode]="false"
                  showBrowserAutocomplete="off">
                </pdq-input>
                @if (field.dropdownOptions) {
                  <pdq-dropdown
                    [options]="field.dropdownOptions"
                    (onChange)="pdqIqForm.controls['field' + i].setValue($event.value)"
                    [defaultOption]="{ label: field.dropdownPlaceholder || 'Select an option', value: '' }">
                  </pdq-dropdown>
                }
                @if (showFormErrors && !pdqIqForm.controls['field' + i].valid) {
                  <mat-error> * {{ field.name }} is required and must be in the format "namespace.key" </mat-error>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <footer [ngClass]="pdqIqForm.dirty ? 'apear' : 'initial'">
        <pdq-button
          variant="secondary"
          [disabled]="isLoading"
          (click)="resetForm()"
          label="cancel"
          class="action-btn"></pdq-button>
        <pdq-button
          variant="primary"
          type="submit"
          label="save"
          class="action-btn"
          (click)="savePdqIq()"
          [loading]="isLoading">
        </pdq-button>
      </footer>
    </div>
  }
</div>
